import { Component, inject } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false
})
export class SidebarComponent {
  private auth = inject(AuthService);

  get isAdmin(): boolean {
    return this.auth.hasRole('ADMIN');
  }
}
